import React from 'react';
import TipModal from './tip-modal';

const { UI, Order } = Mobi2Go;

Order.onReady(() => {
    const modal = UI.ExternalModal.create(
        'order-tip-modal',
        <TipModal
            closeModal={retain_overlay => {
                modal.close(retain_overlay);
            }}
        />,
        {
            'data-view': 'order-tip-modal',
            className: 'm2g-order-tip-modal',
        }
    );

    modal.mount();

    UI.bind('showTip', () => {
        modal.open();

        // Set default tip on display
        const default_tip = Order.getDefaultTip();
        if (default_tip !== null) {
            Order.setTip(default_tip);
        }
    });
});
